@if(!useMuiLayout && !staffFilterBuilder){
<div class="card mb-3 mt-3 pl-4 pr-4" *ngIf="showColumnsSettings">
  <div class="row justify-content-between">
    <!-- filters -->
    <div class="col-8 align-self-center" *ngIf="showFilterBuilder">
      <span *ngFor="let filter of filters">
        <ng-template #popContent>
          <div *ngFor="let type of getFilterTypes(filter.param)">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="queryType"
                [id]="type.name"
                [value]="type.name"
                (change)="changeFilterType(filter)"
                [(ngModel)]="filter.queryType"
              />
              <label class="form-check-label" [for]="type.name">
                {{ type.name }}
              </label>
            </div>
            <div
              class="md-form search-form"
              *ngIf="filter.queryType === type.name"
            >
              <select
                *ngIf="
                  (filter.queryType === 'is' ||
                    filter.queryType === 'is not') &&
                  filter.param.options
                "
                class="form-control"
                style="min-width: 200px; max-width:600px;"
                [name]="type.name + '-input'"
                (change)="bypassBinding(filter, $event)"
                [value]="filter.value"
              >
                <option [ngValue]="null" hidden selected>
                  Select an option
                </option>
                <ng-container
                  *ngFor="let opt of getFilterOptions(filter.param)"
                >
                  <option [value]="opt.value">
                    {{ opt.name }}
                  </option>
                </ng-container>
              </select>

              <select
                *ngIf="filter.queryType === 'in' && filter.param.options"
                class="form-control"
                style="min-width: 200px; max-width:600px; min-height: 300px;"
                [name]="type.name + '-input'"
                (change)="bypassBinding(filter, $event)"
                [(ngModel)]="filter.customValue"
                multiple
              >
                <option [ngValue]="null" hidden selected>
                  Select an option
                </option>
                <ng-container
                  *ngFor="let opt of getFilterOptions(filter.param)"
                >
                  <option [value]="opt.value">
                    {{ opt.name }}
                  </option>
                </ng-container>
              </select>

              <div *ngIf="!filter.param.options && filter.queryType === 'in'">
                <input
                  [type]="filter.param.inputType || 'text'"
                  class="form-control"
                  [name]="type.name + '-input'"
                  placeholder=""
                  [attr.aria-describedby]="type.name + '-inputHelp'"
                  (ngModelChange)="filtersChanged()"
                  [(ngModel)]="filter.value"
                />
                <small
                  [id]="type.name + '-inputHelp'"
                  class="form-text text-muted"
                  >Enter a comma separated list of items to search by.</small
                >
              </div>

              <ng-container *ngIf="filter.queryType === 'range'">
                <select
                  class="form-control mb-3"
                  style="min-width: 200px;"
                  [name]="type.name + '-input'"
                  (change)="filtersChanged()"
                  [(ngModel)]="filter.value"
                  *ngIf="filter.param.inputType === 'date'"
                >
                  <ng-container
                    *ngFor="let opt of getFilterRangeOptions(filter.param)"
                  >
                    <option [value]="opt.value">
                      {{ opt.name }}
                    </option>
                  </ng-container>
                </select>

                <!-- custom absolute date ranges -->
                <ng-container
                  *ngIf="
                    filter.value === 'custom' ||
                    filter.param.inputType === 'text' ||
                    filter.param.inputType === 'number'
                  "
                >
                  <div class="form-group">
                    <label [for]="type.name + '-custom-input-start'"
                      >From</label
                    >
                    <input
                      [type]="filter.param.inputType"
                      class="form-control"
                      [name]="type.name + '-custom-input-start'"
                      placeholder=""
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.start"
                      *ngIf="(filter.param.options || []).length === 0"
                    />
                  </div>
                  <select
                    *ngIf="(filter.param.options || []).length !== 0"
                    class="form-control"
                    [name]="type.name + '-custom-input-start'"
                    (ngModelChange)="filtersChanged()"
                    [(ngModel)]="filter.customValue.start"
                  >
                    <option></option>
                    <option
                      *ngFor="let o of filter.param.options"
                      [value]="o.value"
                    >
                      {{ o.name }}
                    </option>
                  </select>

                  <div class="form-group">
                    <label [for]="type.name + '-custom-input-end'">To</label>
                    <input
                      [type]="filter.param.inputType"
                      class="form-control"
                      [name]="type.name + '-custom-input-end'"
                      placeholder=""
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.end"
                      *ngIf="(filter.param.options || []).length === 0"
                    />
                    <select
                      *ngIf="(filter.param.options || []).length !== 0"
                      class="form-control"
                      [name]="type.name + '-custom-input-end'"
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.end"
                    >
                      <option></option>
                      <option
                        *ngFor="let o of filter.param.options"
                        [value]="o.value"
                      >
                        {{ o.name }}
                      </option>
                    </select>
                  </div>
                </ng-container>
              </ng-container>

              <input
                *ngIf="
                  (!filter.param.options || filter.queryType === 'contains') &&
                  filter.queryType !== 'range' &&
                  filter.queryType !== 'in' &&
                  filter.queryType !== 'exists' &&
                  filter.queryType !== 'not exists'
                "
                [type]="filter.param.inputType || 'text'"
                class="form-control"
                [name]="type.name + '-input'"
                placeholder=""
                (ngModelChange)="filtersChanged()"
                [(ngModel)]="filter.value"
              />
            </div>
          </div>
          <button
            type="button"
            class="btn btn-block btn-primary"
            (click)="p.close()"
          >
            Done
          </button>
        </ng-template>

        <div
          class="chip"
          [autoClose]="'outside'"
          triggers="manual"
          #p="ngbPopover"
          (click)="openFilter(p)"
          #popovers="ngbPopover"
          [ngbPopover]="popContent"
          container="body"
          placement="bottom"
          [id]="'filter-' + filter.id"
        >
          <span class="font-weight-bold">{{ filter.param.name }}</span>
          {{ filterText(filter) }}

          <fa-icon
            placement="top"
            ngbTooltip="Remove this filter"
            class="close"
            [icon]="faTimes"
            (click)="removeFilter(filter)"
          ></fa-icon>
        </div>
      </span>

      <ng-template #filterPopover>
        <input
          id="typeahead-template"
          type="text"
          class="form-control"
          placeholder="Search..."
          [(ngModel)]="searchModel"
        />
        <ul class="list-group">
          <li
            class="list-group-item"
            style="cursor: pointer;"
            *ngFor="let item of filteredParams"
            (click)="addFilter(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </ng-template>
      <a
        class="btn btn-primary"
        [ngbPopover]="filterPopover"
        #fp="ngbPopover"
        (click)="showFilters()"
        [autoClose]="'outside'"
        triggers="manual"
        container="body"
        placement="bottom"
      >
        + Filter
      </a>
    </div>

    <!-- saved filters -->
    <div
      class="flex-column align-self-center text-right mr-3"
      *ngIf="savedFilters"
    >
      <wm-saved-filter
        [id]="id"
        [getCurrentFilter]="getCurrentFilter"
        [applyFilter]="applyFilter"
        [clientId]="context.client && context.client.id"
      ></wm-saved-filter>
    </div>

    <!--columns button-->
    <div
      class="flex-column align-self-center text-right mr-3"
      [ngClass]="{ 'col-12': !showFilterBuilder }"
      *ngIf="columnOptions"
    >
      <div class="form-group mt-3">
        <!-- only export options -->
        <div
          *ngIf="onlyExportOptions"
          ngbDropdown
          placement="bottom-right"
          (openChange)="dropdownChanged($event)"
          class="d-inline-block"
        >
          <button
            class="btn btn-raised btn-primary float-right"
            id="columns-dropdown"
            ngbDropdownToggle
          >
            Columns <br />
            (
            <span *ngIf="selectedExportColumnsNumber">
              {{ selectedExportColumnsNumber }} / {{ columnOptions.length }}
            </span>
            <span *ngIf="!selectedExportColumnsNumber">
              none
            </span>
            )
          </button>
          <div ngbDropdownMenu aria-labelledby="columns-dropdown">
            <div class="p-3">
              <div class="custom-control custom-checkbox mb-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'selectAll-' + parentId"
                  [name]="'selectAll-' + parentId"
                  (change)="triggerAll($event.target.checked)"
                  [(ngModel)]="allTriggered"
                />
                <label
                  class="custom-control-label"
                  [for]="'selectAll-' + parentId"
                >
                  Select All
                </label>
              </div>

              <div
                class="custom-control custom-checkbox"
                *ngFor="let column of columnOptions"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'column-' + column.name + '-' + parentId"
                  [name]="'column-' + column.name + '-' + parentId"
                  [value]="column.name"
                  [(ngModel)]="column.includeInExport"
                  (ngModelChange)="dropdownChanged($event)"
                />
                <label
                  class="custom-control-label"
                  [for]="'column-' + column.name + '-' + parentId"
                >
                  <span style="text-wrap: nowrap;">
                    {{ column.label }}&nbsp;
                    <fa-icon
                      placement="top"
                      ngbTooltip="GIS data"
                      [icon]="faGlobe"
                      [hidden]="!isGeoJSON(column)"
                    ></fa-icon
                  ></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- column visibility and export options -->
        <div *ngIf="!onlyExportOptions && exportingEnabled">
          <button
            class="btn btn-raised btn-primary"
            (click)="openColumnModal()"
          >
            Columns
          </button>
          <wm-modal-confirm
            #columnOptionsModal
            title="Column Settings"
            commandText="Save"
            [showButton]="false"
            (accepted)="columnModalClosed()"
            (canceled)="columnModalCanceled()"
          >
            <div class="row">
              <div class="col-1"></div>
              <div class="col-4"></div>
              <div class="col-3">
                Show in Grid
              </div>
              <div class="col-3">
                Include in Export
              </div>
              <div class="col-1"></div>
            </div>

            <div class="row" *ngFor="let column of trialColumnOptions">
              <div class="col-1"></div>
              <div class="col-4">
                {{ column.label }}
              </div>
              <div class="col-3">
                <input
                  class="ml-4"
                  type="checkbox"
                  [(ngModel)]="column.checked"
                />
              </div>
              <div class="col-3">
                <input
                  class="ml-5"
                  type="checkbox"
                  [(ngModel)]="column.includeInExport"
                />
              </div>
              <div class="col-1"></div>
            </div>
          </wm-modal-confirm>
        </div>

        <!-- only column visibility options -->
        <div *ngIf="!onlyExportOptions && !exportingEnabled">
          <button
            class="btn btn-raised btn-primary"
            (click)="openColumnModal()"
          >
            Columns
          </button>
          <wm-modal-confirm
            #columnOptionsModal
            title="Column Settings"
            commandText="Save"
            [showButton]="false"
            (accepted)="columnModalClosed()"
            (canceled)="columnModalCanceled()"
            [small]="true"
          >
            <div class="row">
              <div class="col-8"></div>
              <div class="col-4">
                Show
              </div>
            </div>

            <div class="row" *ngFor="let column of trialColumnOptions">
              <div class="col-8">
                {{ column.label }}
              </div>
              <div class="col-4">
                <input
                  class="ml-2"
                  type="checkbox"
                  [(ngModel)]="column.checked"
                />
              </div>
            </div>
          </wm-modal-confirm>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="showSimpleSearch">
  <div class="col-10">
    <input
      id="simplesearch-template"
      type="text"
      class="form-control simpleSearch"
      [placeholder]="simpleSearchTitle"
      (keyup)="simpleSearchKeyUp($event)"
      [(ngModel)]="simpleSearchModel"
    />
  </div>
</div>
}@else if (staffFilterBuilder) {
<div class="filter-card" *ngIf="showColumnsSettings">
  <!-- <div class="row"> -->
  <div class="filter-dropdowns" *ngIf="showFilterBuilder">
    <!-- Added by Amisha on 2026-06-16.
               Reason: widen only the Janus scheduled-export filter trigger to match the approved
               modal controls without affecting shared filter-builder dropdowns elsewhere. -->
    <!-- <div class="row-layout"> -->
      <div class="filter-by-dropdown">
        <wm-common-dropdown
          [data]="filterDropdownData"
          (change)="onFilterDropdownChange($event)"
        >
        </wm-common-dropdown>
      </div>
      <div class="save-dropdown" *ngIf="savedFilters">
        <wm-common-dropdown
          *ngIf="savedFilters"
          [data]="savedFilterDropdownData"
          (change)="onSavedFilterChange($event)"
        >
        </wm-common-dropdown>
      </div>
    <!-- </div> -->
    <!-- Added by Amisha on 2026-06-16.
               Reason: Janus scheduled exports use the footer save action, so the shared inline
               save button must stay hidden for that opt-in path while remaining available elsewhere. -->
    <div
      class="save-btn save-btn-shadow"
      *ngIf="savedFilters && !selectedSavedFilterId && !janusScheduledExport"
    >
      <wm-common-button
        *ngIf="savedFilters && !selectedSavedFilterId && !janusScheduledExport"
        [data]="{ text: 'SAVE' }"
        (click)="openSaveModal(false)"
      >
      </wm-common-button>
    </div>
    <div *ngIf="selectedSavedFilterId" class="filter-by-dropdown center-align">
      <wm-common-dropdown
        [data]="editDropdownData"
        (change)="onEditAction($event)"
      >
      </wm-common-dropdown>
    </div>
    <!-- Columns -->
    <div class="columns-dropdown" *ngIf="columnOptions">
      <div class="save-dropdown center-align">
        <!-- only export options -->
        <!-- Added by Vipul Rathod on 17/07/2026 -->
        <wm-common-dropdown
          *ngIf="onlyExportOptions"
          [data]="columnsDropdownData"
          (checkboxChange)="onColumnCheckboxChanged($event)"
          (selectAllChange)="onColumnSelectAll($event)"
        >
        </wm-common-dropdown>
        <!-- Added by Vipul Rathod on 17/07/2026 -->

        <!-- column visibility and export options -->
        <!-- Added by Vipul Rathod on 17/07/2026 -->
        <wm-common-dropdown
          *ngIf="!onlyExportOptions && exportingEnabled"
          [data]="columnsDropdownData"
          (checkboxChange)="onColumnCheckboxChanged($event)"
          (selectAllChange)="onColumnSelectAll($event)"
        >
        </wm-common-dropdown>
        <!-- End by Vipul Rathod on 17/07/2026 -->

        <!-- only column visibility options -->
        <!-- Added by Vipul Rathod on 17/07/2026 -->
        <wm-common-dropdown
          *ngIf="!onlyExportOptions && !exportingEnabled"
          [data]="columnsDropdownData"
          (checkboxChange)="onColumnCheckboxChanged($event)"
          (selectAllChange)="onColumnSelectAll($event)"
        >
        </wm-common-dropdown>
        <!-- End by Vipul Rathod on 17/07/2026 -->
      </div>
    </div>
  </div>

  <div class="filter-chips" *ngIf="showFilterBuilder">
    <div class="staff-filter-chips">
      <span *ngFor="let filter of filters">
        <ng-template #staffPopContent>
          <div
            *ngFor="let type of getFilterTypes(filter.param)"
            class="new-layout-div"
          >
            <div
              class="form-check"
              [ngClass]="staffFilterBuilder ? 'position-container' : null"
            >
              <input
                class="form-check-input"
                type="radio"
                name="queryType"
                [id]="type.name"
                [value]="type.name"
                (change)="changeFilterType(filter)"
                [(ngModel)]="filter.queryType"
              />
              <label class="form-check-label" [for]="type.name">
                {{ type.name }}
              </label>
            </div>
            <div
              class="md-form search-form"
              *ngIf="filter.queryType === type.name"
            >
              <div
                class="selected-value"
                *ngIf="
                  (filter.queryType === 'is' ||
                    filter.queryType === 'is not') &&
                  filter.param.options
                "
                (click)="openOptionMenu = !openOptionMenu"
              >
                {{ getSelectedOptionName(filter) || 'Select Option' }}
                <div
                  *ngIf="openOptionMenu"
                  class="nested-menu-options"
                  [style.maxHeight.px]="isDateFilterButton ? 500 : 240"
                >
                  <div
                    class="menu-item"
                    *ngFor="let opt of getFilterOptions(filter.param)"
                    [class.active]="filter.value === opt.value"
                    (mousedown)="
                      onOptionSelect(filter, opt); $event.stopPropagation()
                    "
                  >
                    {{ opt.name }}
                  </div>
                  <input
                    type="hidden"
                    [name]="type.name + '-input'"
                    [(ngModel)]="filter.value"
                  />
                </div>
              </div>

              <div
                class="selected-value"
                *ngIf="
                  (filter.queryType === 'in' ||
                    filter.queryType === 'in not') &&
                  filter.param.options
                "
                (click)="openOptionMenu = !openOptionMenu"
              >
                {{ getSelectedOptionInQuery(filter) || 'Select Option' }}
                <div
                  *ngIf="openOptionMenu"
                  class="nested-menu-options"
                  [style.maxHeight.px]="isDateFilterButton ? 500 : 240"
                >
                  <div
                    class="menu-item"
                    *ngFor="let opt of getFilterOptions(filter.param)"
                    [class.active]="isSelected(filter, opt.value)"
                    (click)="
                      onOptionInSelect(filter, opt);
                      $event.stopPropagation();
                      $event.preventDefault()
                    "
                  >
                    {{ opt.name }}
                  </div>
                  <div class="nested-menu-done">
                    <button
                      type="button"
                      class="btn btn-sm btn-primary nested-menu-done__btn"
                      (click)="
                        openOptionMenu = false;
                        $event.stopPropagation();
                        $event.preventDefault()
                      "
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>

              <div *ngIf="!filter.param.options && filter.queryType === 'in'">
                <input
                  [type]="filter.param.inputType || 'text'"
                  class="form-control"
                  [name]="type.name + '-input'"
                  placeholder=""
                  [attr.aria-describedby]="type.name + '-inputHelp'"
                  (ngModelChange)="filtersChanged()"
                  [(ngModel)]="filter.value"
                />
                <small
                  [id]="type.name + '-inputHelp'"
                  class="form-text text-muted"
                  >Enter a comma separated list of items to search by.</small
                >
              </div>

              <ng-container *ngIf="filter.queryType === 'range'">
                <!-- trigger / selected display -->
                <div
                  class="selected-value"
                  *ngIf="
                    filter.queryType === 'range' &&
                    filter.param.inputType === 'date'
                  "
                  (click)="openRangeMenu = !openRangeMenu"
                >
                  {{ getSelectedRangeName(filter) || 'Select range' }}
                </div>

                <!-- dropdown -->
                <div
                  *ngIf="openRangeMenu"
                  class="nested-menu-options"
                  [style.maxHeight.px]="isDateFilterButton ? 500 : 240"
                >
                  <div
                    class="menu-item"
                    *ngFor="let opt of getFilterRangeOptions(filter.param)"
                    [class.active]="filter.value === opt.value"
                    (mousedown)="
                      onDateRangeSelect(filter, opt); $event.stopPropagation()
                    "
                  >
                    {{ opt.name }}
                  </div>

                  <input
                    type="hidden"
                    [name]="type.name + '-input'"
                    [(ngModel)]="filter.value"
                  />
                </div>

                <ng-container
                  *ngIf="
                    filter.value === 'custom' ||
                    filter.param.inputType === 'text' ||
                    filter.param.inputType === 'number'
                  "
                >
                  <div class="form-group">
                    <label [for]="type.name + '-custom-input-start'"
                      >From</label
                    >
                    <input
                      [type]="filter.param.inputType"
                      class="form-control"
                      [name]="type.name + '-custom-input-start'"
                      placeholder=""
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.start"
                      *ngIf="(filter.param.options || []).length === 0"
                    />
                  </div>
                  <select
                    *ngIf="(filter.param.options || []).length !== 0"
                    class="form-control"
                    [name]="type.name + '-custom-input-start'"
                    (ngModelChange)="filtersChanged()"
                    [(ngModel)]="filter.customValue.start"
                  >
                    <option></option>
                    <option
                      *ngFor="let o of filter.param.options"
                      [value]="o.value"
                    >
                      {{ o.name }}
                    </option>
                  </select>

                  <div class="form-group">
                    <label [for]="type.name + '-custom-input-end'">To</label>
                    <input
                      [type]="filter.param.inputType"
                      class="form-control"
                      [name]="type.name + '-custom-input-end'"
                      placeholder=""
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.end"
                      *ngIf="(filter.param.options || []).length === 0"
                    />
                    <select
                      *ngIf="(filter.param.options || []).length !== 0"
                      class="form-control"
                      [name]="type.name + '-custom-input-end'"
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.end"
                    >
                      <option></option>
                      <option
                        *ngFor="let o of filter.param.options"
                        [value]="o.value"
                      >
                        {{ o.name }}
                      </option>
                    </select>
                  </div>
                </ng-container>
              </ng-container>

              <input
                *ngIf="
                  (!filter.param.options || filter.queryType === 'contains') &&
                  filter.queryType !== 'range' &&
                  filter.queryType !== 'in' &&
                  filter.queryType !== 'exists' &&
                  filter.queryType !== 'not exists'
                "
                [type]="filter.param.inputType || 'text'"
                class="form-control"
                [name]="type.name + '-input'"
                placeholder=""
                (ngModelChange)="filtersChanged()"
                [(ngModel)]="filter.value"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button type="button" class="done-button" (click)="p.close()">
              Done
            </button>
          </div>
        </ng-template>

        <div
          [class]="
            staffFilterBuilder
              ? 'staff-chip staff-filter-popover'
              : 'staff-chip'
          "
          [popoverClass]="staffFilterBuilder ? 'staff-filter-popover' : ''"
          [id]="'filter-' + filter.id"
          #popovers="ngbPopover"
          triggers="manual"
          [autoClose]="'outside'"
          #p="ngbPopover"
          [ngbPopover]="staffPopContent"
          container="body"
          placement="bottom"
          (click)="openFilter(p)"
          (hidden)="unlockParentScroll()"
        >
          <wm-common-chip
            [data]="{
              label: filter.param.name + ' ' + filterText(filter),
              removable: true,
              id: 'filter-' + filter.id
            }"
            (onDelete)="removeFilter(filter)"
          >
          </wm-common-chip>
        </div>
      </span>
    </div>
  </div>
  <!-- </div> -->
</div>
<wm-common-confirmation-modal
  [data]="saveModalData"
  (onOkClick)="handleSaveModalOk()"
>
  <div class="form-group">
    <wm-common-textfield
      [(ngModel)]="saveFilterName"
      [data]="{
        label: 'Filter Name',
        placeholder: 'Enter Filter Name'
      }"
    ></wm-common-textfield>
  </div>
</wm-common-confirmation-modal>
}@else{
<div class="filter-menu-container"   [ngStyle]="{
    'row-gap': filters?.length ? '16px' : '0px'
  }"
>
  <div class="content">
    <div class="first-content" *ngIf="!isDataSetFilterButton">
      <wm-common-text
        [data]="{ text: layoutTitle }"
        class="application-title"
      ></wm-common-text>
      <div class="search-input-wrapper">
        <wm-common-textfield
          class="search-field"
          [data]="{
            value: simpleSearchModel,
            startIcon: { matIconName: 'search' },
            placeholder: 'Search'
          }"
          (keyup)="simpleSearchKeyUp($event)"
          (valueChange)="simpleSearchModel = $event"
        >
        </wm-common-textfield>
      </div>
    </div>

    <div class="list-container">
      <ng-template #filterPopover>
        <wm-common-textfield
          class="search-filter"
          [data]="{
            id: 'typeahead-template',
            label: 'Search',
            placeholder: 'Search...',
            value: searchModel
          }"
          (valueChange)="searchModel = $event"
        >
        </wm-common-textfield>
        <div
          class="attribute-dropdown"
          [style.max-height.px]="dropdownMaxHeight"
        >
          <ul class="list-group new-layout">
            <li
              class="list-group-item filter-item"
              *ngFor="let item of filteredParams"
              [class.disabled-item]="isFilterAdded(item)"
              [style.cursor]="isFilterAdded(item) ? 'not-allowed' : 'pointer'"
              (click)="!isFilterAdded(item) && addFilter(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </ng-template>

      @if(!isDataSetFilterButton) {
      <!-- Added by Amisha on 06/15/2026.
               Reason: applicant renewals needs a renewals-only popup class so shared filter-builder
               CSS can reduce popover height and enable internal scrolling without affecting other screens. -->
      <!-- Added by Amisha on 06/17/2026.
               Reason: renewals needs a shorter main Filter by popover without affecting
               my applications and other applicant filter-builder consumers. -->
      <a
        #filterBtn
        type="button"
        class="new-layout-filter-btn"
        [ngbPopover]="filterPopover"
        #fp="ngbPopover"
        (click)="showFilters(fp, filterBtn)"
        [autoClose]="'outside'"
        triggers="manual"
        (shown)="onPopoverShown()"
        (hidden)="onPopoverHidden()"
        container="body"
        [popoverClass]="
          useMuiLayout
            ? 'mui-popover popover-applicant-layout' +
              (keepSearchVisibleOnTopOpen
                ? ' keep-search-visible-on-top-open'
                : '') +
              (id === 'myRenewalsFilters'
                ? ' my-renewals-main-filter-popover'
                : '')
            : ''
        "
      >
        Filter by
        <span class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span> </a
      >} @else{
      <a
        *ngIf="!showFilterBuilder"
        #filterBtn
        type="button"
        class="new-layout-filter-btn"
        [ngbPopover]="filterPopover"
        #fp="ngbPopover"
        (click)="showFilters(fp, filterBtn)"
        [autoClose]="'outside'"
        triggers="manual"
        (shown)="onPopoverShown()"
        (hidden)="onPopoverHidden()"
        container="body"
        [popoverClass]="useMuiLayout ? 'mui-popover popover-main-layout' : ''"
      >
        <span class="material-icons dropdown-icon">
          filter_alt
        </span>
      </a>
      }
      <ng-container *ngIf="sortTemplate">
        <ng-container *ngTemplateOutlet="sortTemplate"></ng-container>
      </ng-container>
    </div>
  </div>

  <div *ngIf="showFilterBuilder" class="filter-builder">
    <div
      class="applicant-filter-chips"
      [ngStyle]="{
        '--filter-max-width':
          isNoData || hasFewData
            ? '100%'
            : isFilterOpen
            ? 'calc(100% - 220px)'
            : externalState?.isOpen || externalState?.placement === 'bottom'
            ? 'calc(100% - 260px)'
            : '100%'
      }"
    >
      <span *ngFor="let filter of filters">
        <ng-template #popContent>
          <div
            *ngFor="let type of getFilterTypes(filter.param)"
            class="new-layout-div"
          >
            <div
              class="form-check"
              [ngClass]="useMuiLayout ? 'position-container' : null"
            >
              <input
                class="form-check-input"
                type="radio"
                name="queryType"
                [id]="type.name"
                [value]="type.name"
                (change)="changeFilterType(filter)"
                [(ngModel)]="filter.queryType"
              />
              <label class="form-check-label" [for]="type.name">
                {{ type.name }}
              </label>
            </div>
            <div
              class="md-form search-form"
              *ngIf="filter.queryType === type.name"
            >
              <div
                class="selected-value"
                *ngIf="
                  (filter.queryType === 'is' ||
                    filter.queryType === 'is not') &&
                  filter.param.options
                "
                (click)="toggleOptionMenu($event)"
              >
                {{ getSelectedOptionName(filter) || 'Select Option' }}
                <div
                  *ngIf="openOptionMenu"
                  class="nested-menu-options"
                  [style.maxHeight.px]="nestedDropdownMaxHeight"
                  [class.open-up]="openUp"
                >
                  <div
                    class="menu-item"
                    *ngFor="let opt of getFilterOptions(filter.param)"
                    [class.active]="filter.value === opt.value"
                    (mousedown)="
                      onOptionSelect(filter, opt); $event.stopPropagation()
                    "
                  >
                    {{ opt.name }}
                  </div>
                  <input
                    type="hidden"
                    [name]="type.name + '-input'"
                    [(ngModel)]="filter.value"
                  />
                </div>
              </div>

              <div
                class="selected-value"
                *ngIf="
                  (filter.queryType === 'in' ||
                    filter.queryType === 'in not') &&
                  filter.param.options
                "
                (click)="toggleOptionMenu($event)"
              >
                {{ getSelectedOptionInQuery(filter) || 'Select Option' }}
                <div
                  *ngIf="openOptionMenu"
                  class="nested-menu-options"
                  [style.maxHeight.px]="nestedDropdownMaxHeight"
                  [class.open-up]="openUp"
                >
                  <div
                    class="menu-item"
                    *ngFor="let opt of getFilterOptions(filter.param)"
                    [class.active]="isSelected(filter, opt.value)"
                    (click)="
                      onOptionInSelect(filter, opt);
                      $event.stopPropagation();
                      $event.preventDefault()
                    "
                  >
                    {{ opt.name }}
                  </div>
                  <div class="nested-menu-done">
                    <button
                      type="button"
                      class="btn btn-sm btn-primary nested-menu-done__btn"
                      (click)="
                        openOptionMenu = false;
                        $event.stopPropagation();
                        $event.preventDefault()
                      "
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>

              <div *ngIf="!filter.param.options && filter.queryType === 'in'">
                <input
                  [type]="filter.param.inputType || 'text'"
                  class="form-control"
                  [name]="type.name + '-input'"
                  placeholder=""
                  [attr.aria-describedby]="type.name + '-inputHelp'"
                  (ngModelChange)="filtersChanged()"
                  [(ngModel)]="filter.value"
                />
                <small
                  [id]="type.name + '-inputHelp'"
                  class="form-text text-muted"
                  >Enter a comma separated list of items to search by.</small
                >
              </div>

              <ng-container *ngIf="filter.queryType === 'range'">
                <!-- trigger / selected display -->
                <div
                  class="selected-value"
                  *ngIf="
                    filter.queryType === 'range' &&
                    filter.param.inputType === 'date'
                  "
                  (click)="openRangeMenu = !openRangeMenu"
                >
                  {{ getSelectedRangeName(filter) || 'Select range' }}
                </div>

                <!-- dropdown -->
                <div *ngIf="openRangeMenu" class="nested-menu-options">
                  <div
                    class="menu-item"
                    *ngFor="let opt of getFilterRangeOptions(filter.param)"
                    [class.active]="filter.value === opt.value"
                    (mousedown)="
                      onDateRangeSelect(filter, opt); $event.stopPropagation()
                    "
                  >
                    {{ opt.name }}
                  </div>

                  <input
                    type="hidden"
                    [name]="type.name + '-input'"
                    [(ngModel)]="filter.value"
                  />
                </div>

                <ng-container
                  *ngIf="
                    filter.value === 'custom' ||
                    filter.param.inputType === 'text' ||
                    filter.param.inputType === 'number'
                  "
                >
                  <div class="form-group">
                    <label [for]="type.name + '-custom-input-start'"
                      >From</label
                    >
                    <input
                      [type]="filter.param.inputType"
                      class="form-control"
                      [name]="type.name + '-custom-input-start'"
                      placeholder=""
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.start"
                      *ngIf="(filter.param.options || []).length === 0"
                    />
                  </div>
                  <select
                    *ngIf="(filter.param.options || []).length !== 0"
                    class="form-control"
                    [name]="type.name + '-custom-input-start'"
                    (ngModelChange)="filtersChanged()"
                    [(ngModel)]="filter.customValue.start"
                  >
                    <option></option>
                    <option
                      *ngFor="let o of filter.param.options"
                      [value]="o.value"
                    >
                      {{ o.name }}
                    </option>
                  </select>

                  <div class="form-group">
                    <label [for]="type.name + '-custom-input-end'">To</label>
                    <input
                      [type]="filter.param.inputType"
                      class="form-control"
                      [name]="type.name + '-custom-input-end'"
                      placeholder=""
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.end"
                      *ngIf="(filter.param.options || []).length === 0"
                    />
                    <select
                      *ngIf="(filter.param.options || []).length !== 0"
                      class="form-control"
                      [name]="type.name + '-custom-input-end'"
                      (ngModelChange)="filtersChanged()"
                      [(ngModel)]="filter.customValue.end"
                    >
                      <option></option>
                      <option
                        *ngFor="let o of filter.param.options"
                        [value]="o.value"
                      >
                        {{ o.name }}
                      </option>
                    </select>
                  </div>
                </ng-container>
              </ng-container>

              <input
                *ngIf="
                  (!filter.param.options || filter.queryType === 'contains') &&
                  filter.queryType !== 'range' &&
                  filter.queryType !== 'in' &&
                  filter.queryType !== 'exists' &&
                  filter.queryType !== 'not exists'
                "
                [type]="filter.param.inputType || 'text'"
                class="form-control"
                [name]="type.name + '-input'"
                placeholder=""
                (ngModelChange)="filtersChanged()"
                [(ngModel)]="filter.value"
              />
            </div>
          </div>
          <div class="button-content">
            <button type="button" class="done-button" (click)="p.close()">
              Done
            </button>
          </div>
        </ng-template>

        <!-- Added by Amisha on 06/17/2026.
               Reason: renewals chip popovers still need overflow-visible nested menus even though
               the main renewals Filter by popover now scrolls internally. -->
        <div
          #chipEl
          class="applicant-chip"
          [class.simu-layout]="useMuiLayout"
          [autoClose]="'outside'"
          triggers="manual"
          #p="ngbPopover"
          (click)="
            !isDataSetFilterButton ? openFilter(p, chipEl) : openFilter(p)
          "
          #popovers="ngbPopover"
          [ngbPopover]="popContent"
          container="body"
          [placement]="getPlacement()"
          [id]="'filter-' + filter.id"
          [popoverClass]="
            useMuiLayout
              ? 'mui-popover ' +
                ([
                  'in',
                  'is',
                  'range',
                  'exists',
                  'not exists',
                  '<=',
                  '>=',
                  'is not',
                  '>',
                  '<',
                  'not contains',
                  'contains'
                ].includes(filter.queryType)
                  ? 'popover-in-layout '
                  : '') +
                (isNoData ? 'no-data-popover' : '') +
                (isDataSetFilterButton ? 'dataset-filter-popover' : '') +
                (id === 'myRenewalsFilters' ? ' my-renewals-chip-popover' : '')
              : ''
          "
        >
          <wm-common-chip
            [data]="{
              label: filter.param.name + ' ' + filterText(filter),
              removable: true,
              id: 'filter-' + filter.id
            }"
            (onDelete)="removeFilter(filter)"
          >
          </wm-common-chip>
        </div>
      </span>
    </div>
  </div>
</div>

}
